import {IAnalyticsPeriod} from '../../models/Analytics/IOrderAnalytics';

export const getCurrentMonth = (now = new Date()): IAnalyticsPeriod => {
    const year = String(now.getFullYear()).padStart(4, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
    return {from: year + '-' + month + '-01', to: year + '-' + month + '-' + lastDay};
};

const isDate = (value: string) => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value) || value < '0001-01-01' || value > '9999-12-30') return false;
    const date = new Date(value + 'T00:00:00Z');
    return !Number.isNaN(date.getTime()) && date.toISOString().slice(0, 10) === value;
};

export const isValidAnalyticsPeriod = ({from, to}: IAnalyticsPeriod) => isDate(from) && isDate(to) && from <= to;
